module.exports = __webpack_public_path__ + "static/scale-model-of-eugene-oregon-2692e28b55b310851667a66b71eeaa4f.png";